export default "__VITE_ASSET__152e7e57__"